import { cx } from 'class-variance-authority';
import type {
  FC,
  HTMLAttributes,
  PropsWithChildren,
} from 'react';

export const Services_Body: FC<
  PropsWithChildren & {
    rowProps?: HTMLAttributes<HTMLDivElement>;
  }
> = ({ rowProps = {}, children }) => {
  const { className: _rowClassName, ...restRowProps } =
    rowProps;
  return (
    <main className="container">
      <div
        className={cx('row', _rowClassName)}
        {...restRowProps}
      >
        <div className="col-xxs-12">{children}</div>
      </div>
    </main>
  );
};
